import { useState } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { FeedbackPostDTO } from "../../types/FeedbackPostDTO";
import "./FeedbackPost.css";
import { ThumbsUp, Check } from "lucide-react";

interface Props {
  post: FeedbackPostDTO;
  variant: "manager" | "default";
  onLike: (postId: number) => void;
  onComplete?: (id: number) => void;
}

function FeedbackPost({ post, variant = "default", onLike, onComplete }: Props) {
  const { user } = useAuth();
  const [showLikes, setShowLikes] = useState(false);
  const hasLikes = post.likedBy.length !== 0;

  let timeoutRef: ReturnType<typeof setTimeout>;

  function handleMouseEnter() {
    if (hasLikes) {
      timeoutRef = setTimeout(() => {
        setShowLikes(true);
      }, 500);
    }
  }

  function handleMouseLeave() {
    if (hasLikes) {
      clearTimeout(timeoutRef);
      setShowLikes(false);
    }
  }

  return (
    <>
      <div className="feedback-card">
        <div className="feedback-card-header">
          <h3>{post.title}</h3>
          <span className="impact">
            {post.impact === "Low" ? "Tief" : post.impact === "Medium" ? "Mittel" : "Hoch"}
          </span>
        </div>

        <p>{post.description}</p>

        <div className="feedback-meta">Erstellt von {post.createdBy}</div>

        <div className="feedback-actions">
          <div
            className="likes"
            onClick={() => onLike(post.id)}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <ThumbsUp
              size={30}
              fill={post.likedBy.some((l) => l.id === user?.id) ? "#ffb27a" : "#00000000"}
            />
            <span>{post.likeCount}</span>
            {showLikes && (
              <div className="likes-popover">
                <div className="likes-title">Gefällt</div>

                <div className="likes-list">
                  {post.likedBy.map((l) => (
                    <div key={l.id} className="like-user">
                      <div className="avatar">{l.name.charAt(0).toUpperCase()}</div>
                      <span>{l.name}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          {variant === "manager" && (
            <button
              className="complete-btn"
              onClick={() => onComplete?.(post.id)}
              title="Abschliessen"
              disabled={post.isCompleted}
            >
              <Check size={30} />
            </button>
          )}
        </div>
      </div>
    </>
  );
}

export default FeedbackPost;
